import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { esFolio } from "app/logic/guias";

export interface FolioGuia {
    folio: string;
}

type Entity = FolioGuia;
export interface Props extends kea.ModalProps<Entity, boolean, undefined> {
}

function folioValido(folio: string): boolean {
    return esFolio(folio);
}

/**
 * Valida un FolioGuia
 */
export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = {
        folio: x =>
            x.folio == null ? "Requerido" :
                !folioValido(x.folio) ? "Folio incorrecto" :
                    true
    };
    return validation.getErrors(rules, x);
}

/**
* Modal de edición para un FolioGuia
*/
export class FolioGuiaEdit extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    onGuardar = () => {
        this.props.onClose(true);
    };

    onCerrar = () => {
        this.props.onClose(false);
    }
    render() {
        const value = this.props.value;
        const getField = this.getField;
        const hasError = this.hasError(this.props);

        const Text = getField(kea.Text);
        const DateTime = getField(kea.DateTime);

        return (
            <kea.Modal
                buttons={[<kea.GuardarButton onClick={this.onGuardar} disabled={hasError} />]}
                onClose={this.onCerrar}
                title="Agregar guía al rastreo"
            >

                {kea.autogrid(3, [
                    <Text field="folio" label="Número de guia" disableFastInput />
                ])}
            </kea.Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/rastreo/folio.tsx